import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-history',
  templateUrl: './review-history.component.html',
  styleUrls: ['./review-history.component.css']
})
export class ReviewHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
